// RestoYaar Connect (brand bible §64): this page is being used from outside the
// restaurant, through the tunnel, at https://<install>.r.restoyaar.in.
export const REMOTE_SUFFIX = ".r.restoyaar.in";
export const DASH_URL = "https://dash.restoyaar.in";

export const isRemote = (hostname = window.location.hostname) =>
  typeof hostname === "string" && hostname.toLowerCase().endsWith(REMOTE_SUFFIX);
